import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { ReactNode } from "react";

interface SiteHeaderProps {
    title?: string | ReactNode;
    subtitle?: string | ReactNode;
    backButton?: ReactNode;  // Back/navigation button (left side)
    children?: ReactNode;    // Action buttons (right side)
}

export function SiteHeader({ title, subtitle, backButton, children }: SiteHeaderProps) {
    return (
        <header className="flex h-14 shrink-0 items-center gap-2 border-b bg-background transition-[width,height] ease-linear">
            <div className="flex w-full items-center gap-1 px-4 lg:gap-2 lg:px-6">
                <SidebarTrigger className="-ml-1" />
                <Separator
                    orientation="vertical"
                    className="mx-1 h-4"
                />
                {backButton && (
                    <>
                        {backButton}
                        <Separator
                            orientation="vertical"
                            className="mx-1 h-4"
                        />
                    </>
                )}
                {title && (
                    <div className="flex flex-col gap-1">
                        <div className="text-base font-semibold leading-none">{title}</div>
                        {subtitle && (
                            <div className="text-xs text-muted-foreground/70 leading-none">{subtitle}</div>
                        )}
                    </div>
                )}
                <div className="ml-auto flex items-center gap-2">
                    {children}
                </div>
            </div>
        </header>
    );
}
